<script>
  import Modal from "../../components/Modal.svelte";
  import ChartFollowers from "./ChartFollowers.svelte";

  let { profile, formatNumber, data, chartDateLabels } = $props();

  let showFollowersModal = $state(false);

  function openFollowersModal() {
    showFollowersModal = true;
  }
</script>

<div class="bg-white shadow rounded-lg p-3 sm:p-6">
  <div class="flex justify-between items-start">
    <div>
      <p class="text-xs sm:text-sm font-medium text-gray-500">
        Total Followers
      </p>
      <h3 class="text-xl sm:text-3xl font-bold text-gray-900 mt-1">
        {formatNumber(profile.followers_count)}
      </h3>
    </div>
    <div class="bg-indigo-100 p-1.5 sm:p-2 rounded-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4 sm:h-6 sm:w-6 text-indigo-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
    </div>
  </div>
  <div class="mt-1 sm:mt-2 flex items-center justify-end">
    <button
      onclick={openFollowersModal}
      class="cursor-pointer text-xs text-indigo-600 hover:text-indigo-800 font-medium flex items-center"
    >
      See More
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-3 w-3 ml-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  </div>
</div>

<Modal
  open={showFollowersModal}
  title="Followers Growth"
  size="5xl"
  closed={() => (showFollowersModal = false)}
>
  {#snippet content()}
    <div class="space-y-4">
      <div class="flex items-center">
        <div
          class="flex-shrink-0 bg-gradient-to-r from-indigo-400 to-indigo-600 p-3 rounded-full"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
        </div>
        <div class="ml-5">
          <h3 class="text-xl font-bold text-gray-900">
            Current Followers: <span class="text-indigo-600"
              >{formatNumber(profile.followers_count)}</span
            >
          </h3>
        </div>
      </div>

      <div class="bg-indigo-50 border-l-4 border-indigo-400 p-4 rounded-md">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg
              class="h-5 w-5 text-indigo-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-indigo-700">
              Track follower growth over time to understand audience engagement
              and content performance trends.
            </p>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <ChartFollowers {data} {chartDateLabels} isInModal={true} />
      </div>
    </div>
  {/snippet}
</Modal>
